interface JiraOption {
	id: string;
	value: string;
	__typename: string; // This will always be 'JiraOption' in this context
}

interface JiraCascadingOptions {
	parentOptionValue: JiraOption;
	childOptionValues: JiraOption[];
	__typename: string; // This will always be 'JiraCascadingOptions' in this context
}

export type JiraCascadingOptionsArray = JiraCascadingOptions[];

type JiraCascadingOption = {
	parentOptionValue: JiraOption | null;
	childOptionValue: JiraOption | null;
	__typename: string;
};

export const getCascadingSelectFieldValue = ({
	parentOptionId,
	childOptionId,
	allowedValues,
}: {
	parentOptionId: unknown;
	childOptionId: unknown;
	allowedValues: JiraCascadingOptionsArray;
}) => {
	const defaultValue: JiraCascadingOption = {
		parentOptionValue: null,
		childOptionValue: null,
		__typename: 'JiraCascadingOption',
	};
	if (
		(typeof parentOptionId === 'string' || typeof parentOptionId === 'number') &&
		(typeof childOptionId === 'string' || typeof childOptionId === 'number') &&
		Array.isArray(allowedValues)
	) {
		for (const parentValue of allowedValues) {
			if (parentValue.parentOptionValue.id === parentOptionId.toString()) {
				defaultValue.parentOptionValue = parentValue.parentOptionValue;
				for (const childValue of parentValue.childOptionValues) {
					if (childValue.id === childOptionId.toString()) {
						defaultValue.childOptionValue = childValue;
						return defaultValue;
					}
				}
			}
		}
		if (defaultValue.parentOptionValue === null) return null;
		return defaultValue;
	}
	return null;
};
